import {
  GO_TO_OVERVIEW,
  ADD_EVENT,
  ADD_EVENT_TYPE,
  UPDATE_PROPS,
  BACK,
  FORM_DELETE,
  FORM_SUBMIT,
  SET_FORM_VALIDITY,
  EDIT_EVENT,
  LOADING,
  LOADING_COMPLETE
} from './actions'

export const SCREEN_STATES = {
  OVERVIEW: 'index',
  EVENT_TYPE: 'eventType',
  EVENT_FORM: 'eventForm'
}

export const FORM_STATES = {
  NEW: 'new',
  EDIT: 'edit'
}

export const EVENT_TYPES = {
  INCOME: 'income',
  EXPENSE: 'expense'
}

export default function cashflowEventsReducer(state, { type, payload }) {
  switch (type) {
    case GO_TO_OVERVIEW:
      return {
        ...state,
        cameFrom: state.screen,
        screen: SCREEN_STATES.OVERVIEW,
        joint: false,
      }
    case ADD_EVENT:
      return {
        ...state,
        screen: SCREEN_STATES.EVENT_TYPE,
        cameFrom: SCREEN_STATES.OVERVIEW,
        invalidToggleId: null,
        joint: payload.joint,
      }
    case ADD_EVENT_TYPE:
      return {
        ...state,
        eventType: payload.eventType,
        screen: SCREEN_STATES.EVENT_FORM,
        formState: FORM_STATES.NEW,
        cameFrom: SCREEN_STATES.EVENT_TYPE,
        eventAttributes: null,
        isFormValid: true
      }

    case LOADING:
      return {
        ...state,
        loading: true
      }

    case LOADING_COMPLETE:
      return {
        ...state,
        loading: false
      }

    case UPDATE_PROPS:
      return {
        ...state,
        cashflowEvents: payload.props.cashflowEvents,
        editedProjectionData: payload.props.editedProjectionData,
        expectedAge: payload.props.expectedAge,
      }
    case BACK:
      return {
        ...state,
        screen: state.cameFrom,
        joint: state.cameFrom === SCREEN_STATES.OVERVIEW ? false : state.joint,
        cameFrom: state.screen,
        isFormValid: true
      }
    case SET_FORM_VALIDITY:
      return {
        ...state,
        isFormValid: payload.formValidity
      }
    case FORM_DELETE:
      return {
        ...state,
        screen: SCREEN_STATES.OVERVIEW,
        joint: false,
        eventType: null,
      }
    case FORM_SUBMIT:
      return {
        ...state,
        screen: SCREEN_STATES.OVERVIEW,
        joint: false,
        eventType: null,
        loading: false
      }
    case EDIT_EVENT:
      return {
        ...state,
        screen: SCREEN_STATES.EVENT_FORM,
        cameFrom: SCREEN_STATES.OVERVIEW,
        eventAttributes: payload.event,
        eventType: payload.event.event_type,
        joint: payload.joint,
        formState: FORM_STATES.EDIT,
      }
    default:
      return state
  }
}
